import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: '/',
		name: 'PageView',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
			path: '/',
			redirect: '/home'
		}, {
			path: '/home',
			name: 'home',
			component: resolve => require(['@/view/HomePage'], resolve),
			meta: {
				title: '首页'
			}
		}, {
			path: '/watch',
			name: 'watch',
			component: resolve => require(['@/view/watch'], resolve),
			meta: {
				title: '西部研究'
			}
		}, {
			path: '/companyintroduction',
			name: 'companyintroduction',
			component: resolve => require(['@/view/CompanyIntroduction'], resolve),
			meta: {
				title: '企业介绍'
			}
		}, {
			path: '/phone',
			name: 'phone',
			component: resolve => require(['@/view/phone'], resolve),
			meta: {
				title: '协会动态'
			}
		}]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js